import React from 'react'
import { useOportunidades } from './useOportunidades'
import { applyQuotaToItems } from '../services/opportunityAccessService'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { isMasterByEmail } from '@/shared/utils/role'
import { useQuota } from '../context/QuotaContext'
import { getAllowedSymbolsForCurrentUser } from '@/modules/plans/services/planAssetPolicyService'

export function useOportunidadesQuota() {
  const { user, profile } = useAuth()
  const base = useOportunidades()
  const [exceeded, setExceeded] = React.useState(false)
  const [nextResetAt, setNextResetAt] = React.useState<string | null>(null)
  const { setQuota } = useQuota()

  const isMaster = isMasterByEmail(user?.email) || profile?.role === 'master'

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      if (base.loading || base.error || !base.items) return
      if (isMaster) {
        setExceeded(false)
        setNextResetAt(null)
        try { setQuota({ exceeded: false, nextResetAt: null, resolved: true }) } catch {}
        return
      }
      try {
        // 1) Gate por plano: moedas permitidas para o usu\u00E1rio atual
        let items = base.items
        try {
          const allowed = await getAllowedSymbolsForCurrentUser()
          if (allowed && allowed.length > 0) {
            const set = new Set(allowed.map((s) => String(s || '').trim().toUpperCase()))
            items = items.filter((it) => set.has(String(it.symbol || '').trim().toUpperCase()))
          }
        } catch {
          // Em falha na resolu\u00E7\u00E3o das moedas, mantemos a lista original (fail-open)
        }

        // 2) Gate por cota (limites do plano)
        const gated = await applyQuotaToItems(items)
        if (!mounted) return
        // Substitui itens pela lista filtrada
        // Observa\u00E7\u00E3o: n\u00E3o reescrevemos no hook base para manter SRP
        ;(base as any).items = gated.items
        setExceeded(gated.exceeded)
        setNextResetAt(gated.nextResetAt)
        try { setQuota({ exceeded: gated.exceeded, nextResetAt: gated.nextResetAt || null, resolved: true }) } catch {}
      } catch {
        // Em falha, n\u00E3o bloqueia, mas mant\u00E9m sinaliza\u00E7\u00E3o desligada
        if (!mounted) return
        setExceeded(false)
        setNextResetAt(null)
        try { setQuota({ exceeded: false, nextResetAt: null, resolved: true }) } catch {}
      }
    })()
    return () => { mounted = false }
  }, [base.loading, base.error, base.items?.length, isMaster])

  return { ...base, exceeded, nextResetAt }
}

